import { TIMESLOT_OPTIONS, TShipmentAddress } from '@types';

export const getTimeSlotStatus = (dest: TShipmentAddress): TIMESLOT_OPTIONS => {
	if (dest.carrier_must_book_slot) return TIMESLOT_OPTIONS.OFLOAD_MUST_BOOK;
	if (dest.carrier_must_call_before) return TIMESLOT_OPTIONS.BOOKED;
	return TIMESLOT_OPTIONS.NOT_REQUIRED;
}
